/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {ExistedUserInfo} from '../models/ExistedUserInfo';
import type {UserByEmail} from '../models/UserByEmail';

export interface GetUserByEmail$Request {
    userEmail?: string;
}

export interface GetUserByEmail$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserByEmailRequest = createAction<PayloadData<void, GetUserByEmail$Request>>('GET_USER_BY_EMAIL__GET_USER_BY_EMAIL__REQUEST');
export const getUserByEmailSuccess = createAction<PayloadData<UserByEmail, GetUserByEmail$Request>>('GET_USER_BY_EMAIL__GET_USER_BY_EMAIL__SUCCESS');
export const getUserByEmailFailure = createAction<PayloadData<Error, GetUserByEmail$Request, true>>('GET_USER_BY_EMAIL__GET_USER_BY_EMAIL__FAILURE');

export const getUserByEmailActions = [
    getUserByEmailRequest,
    getUserByEmailSuccess,
    getUserByEmailFailure
] as const;

/**
 * @param {string} [meta.userEmail] User email
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserByEmail = (meta: GetUserByEmail$Request, config?: GetUserByEmail$Config) => {
    const TRANSPORT_GET_PARAMS = {
        userEmail: meta.userEmail,
    };
    return {
        CALL_API: {
            types: getUserByEmailActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/emails/search`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUsersByEmails$Request {
    requestBody: Array<string>;
}

export interface GetUsersByEmails$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUsersByEmailsRequest = createAction<PayloadData<void, GetUsersByEmails$Request>>('GET_USER_BY_EMAIL__GET_USERS_BY_EMAILS__REQUEST');
export const getUsersByEmailsSuccess = createAction<PayloadData<Array<ExistedUserInfo>, GetUsersByEmails$Request>>('GET_USER_BY_EMAIL__GET_USERS_BY_EMAILS__SUCCESS');
export const getUsersByEmailsFailure = createAction<PayloadData<Error, GetUsersByEmails$Request, true>>('GET_USER_BY_EMAIL__GET_USERS_BY_EMAILS__FAILURE');

export const getUsersByEmailsActions = [
    getUsersByEmailsRequest,
    getUsersByEmailsSuccess,
    getUsersByEmailsFailure
] as const;

/**
 * @param {Array<string>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUsersByEmails = (meta: GetUsersByEmails$Request, config?: GetUsersByEmails$Config) => {
    return {
        CALL_API: {
            types: getUsersByEmailsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/emails/search`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

